export default __webpack_public_path__ + "static/media/bangladesh.898a2357.svg";